import { CANCEL_MOTORISTA_CADASTRO_RAPIDO, CANCEL_MOTORISTA_CADASTRO_RAPIDO_SUCCESS } from '@handler';
import {
    NEW_MOTORISTA_CADASTRO_SUCCESS,
    TABLE_MOTORISTA_CADASTRO_PENDING,
    TABLE_MOTORISTA_CADASTRO_SUCCESS,
    TABLE_MOTORISTA_CADASTRO_FAILURE,
    LIST_MOTORISTA_CADASTRO_PENDING,
    LIST_MOTORISTA_CADASTRO_SUCCESS,
    LIST_MOTORISTA_CADASTRO_FAILURE,
    FIND_MOTORISTA_CADASTRO_PENDING,
    FIND_MOTORISTA_CADASTRO_SUCCESS,
    FIND_MOTORISTA_CADASTRO_FAILURE,
    DELETE_MOTORISTA_CADASTRO_PENDING,
    DELETE_MOTORISTA_CADASTRO_SUCCESS,
    DELETE_MOTORISTA_CADASTRO_FAILURE,
    CREATE_MOTORISTA_CADASTRO_PENDING,
    CREATE_MOTORISTA_CADASTRO_SUCCESS,
    CREATE_MOTORISTA_CADASTRO_FAILURE,
    NEW_FILTER_MOTORISTA_CADASTRO_PENDING,
    NEW_FILTER_MOTORISTA_CADASTRO_SUCCESS,
    NEW_FILTER_MOTORISTA_CADASTRO_FAILURE,
    NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_PENDING,
    NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_SUCCESS,
    NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_FAILURE,
} from './actionTypes';
import { CONST_ROWS_PER_PAGE } from '@commons/consts';


const initialState = {
  list: null,
  loading: false,
  filter: {
    rows: CONST_ROWS_PER_PAGE,
    page: 0,
    where: '',
  },
};

function motoristaCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_MOTORISTA_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case LIST_MOTORISTA_CADASTRO_PENDING:
        case FIND_MOTORISTA_CADASTRO_PENDING:
        case DELETE_MOTORISTA_CADASTRO_PENDING:
        case CREATE_MOTORISTA_CADASTRO_PENDING:
        case TABLE_MOTORISTA_CADASTRO_PENDING:
        case NEW_FILTER_MOTORISTA_CADASTRO_PENDING:
        case NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_MOTORISTA_CADASTRO_RAPIDO:
        case CANCEL_MOTORISTA_CADASTRO_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_MOTORISTA_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_MOTORISTA_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_MOTORISTA_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_MOTORISTA_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_MOTORISTA_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_MOTORISTA_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_MOTORISTA_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_MOTORISTA_CADASTRO_SUCCESS:
        case CREATE_MOTORISTA_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_MOTORISTA_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_MOTORISTA_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        case NEW_FILTER_MOTORISTA_CADASTRO_FAILURE: {
            return {
                ...state,
                loading: false
            }
        }
        case NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        case NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_FAILURE: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { motoristaCadastroReducer };